import { ReactNode } from 'react';
import {
  Flex,
  FlexProps,
  GridItem,
  Icon,
  IconName,
  Link,
  LinkProps
} from '../../../atoms';

type QuickLinkProps = {
  children?: ReactNode;
  icon?: JSX.Element;
  to: LinkProps['to'];
} & FlexProps;

function QuickLink({
  children,
  to,
  icon = <Icon name={IconName.ArrowRight} h=".8rem" color="palette_blue.100" />,
  ...rest
}: QuickLinkProps): JSX.Element {
  return (
    <GridItem
      backgroundColor="palette_blue.10"
      borderRadius="10px"
      cursor="pointer"
      width="full"
      p="space_unit.x2"
      as={Link}
      to={to}
      _hover={{ textDecoration: 'none' }}
      {...rest}
    >
      <Flex w={'100%'} justifyContent="space-between" alignItems="center">
        {children}
        {icon}
      </Flex>
    </GridItem>
  );
}

export { QuickLink, QuickLinkProps };
